import axios from "axios";
import {authtoken_app} from '@/values/private';

export default {
  namespaced: true,
  state: {
    invoices: [],
    images: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    invoicesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    SET_QUERY(state, payload) {
      state = Object.assign(state, {query: payload});
      console.log('set', state.query )
    },
    FINDING_INVOICES(state, payload) {
      state.isReceiving = true;
      state.query = Object.assign({}, payload);
    },
    RECEIVED_INVOICES(state, payload) {
      state.invoices = payload;
      state.isReceiving = false;
    },
    RECEIVED_INVOICE(state, payload) {
      let find = state.invoices.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { invoices: [payload, ...state.invoices] });
      }
      else {
        let index = state.invoices.findIndex(i => i._id === payload._id);
        state.invoices.splice(index, 1, payload);
      }
    },
    RECEIVING_INVOICES(state) {
      state.isReceiving = true;
    },
    RECEIVING_INVOICE(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    UPDATED_INVOICE(state, payload) {
      let index = state.invoices.findIndex(invoice => invoice._id === payload._id);
      state = Object.assign(state, {
        invoices: state.invoices.map((invoice, i) => {
          if (i === index) {
            return Object.assign({}, invoice, payload);
          }
          return invoice;
        }),
        isUpdating: false,
        invoicesMessage: 'Invoices has been updating!',
      })
    },
    UPDATING_INVOICE(state) {
      state.isUpdating = true;
    },
    DELETED_INVOICE(state, payload) {
      let indexToDelete = state.invoices.findIndex(invoice => invoice._id === payload._id);
      let invoices = [...state.invoices];
      invoices.splice(indexToDelete, 1);
      state = Object.assign(state, {
        invoices: [...invoices],
        isDeleting: false,
        idToDelete: null,
        invoicesMessage: 'Invoice has been Deleted!',
      });
    },
    DELETING_INVOICE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteInvoiceRequest({dispatch}, payload) {
      dispatch("deletingInvoice", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/invoice/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteInvoice", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteInvoiceTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/invoicetransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertInvoiceRequest({dispatch}, payload) {
      dispatch("receivingInvoices");
      var token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/insert/invoice';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      console.log('Insert', data)
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveInvoice", response.data);
      return response.data;
    },
    async insertInvoiceTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/invoicetransaction/" + payload.invoiceid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getInvoicesRequest({dispatch}) {
      dispatch("receivingInvoices");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/invoices';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveInvoices", response.data);
      })
    },
    async getInvoiceRequest({dispatch}, id) {
      dispatch("receivingInvoice");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/invoice/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveInvoice", response.data);
      })
    },
    async getInvoiceByIdRequest({dispatch}, id) {
      dispatch("doNothing");
      let url = 'https://api.tradexc.com:3010/web-api/get/invoice/' + id;
      let headers = {'Content-Type': 'application/json', 'authtoken': authtoken_app};
      let response = await axios({method: "get", url: url, headers: headers});
      return response.data;
    },
    async findInvoicesRequest({dispatch}, payload) {
      try{
        dispatch("findingInvoices", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/invoices';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInvoices", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInvoiceRequest({dispatch}, payload) {
      dispatch("updatingInvoice");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/invoice/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateInvoice", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateInvoiceTransaction({dispatch}, payload) {
      try{
        dispatch("receivingInvoice");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/invoicetransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingInvoice", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInvoiceSendRequest({dispatch}, payload) {
      dispatch("updatingInvoice");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/invoice/send/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updatingInvoice", response.data);
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING");
    },
    setQuery({commit}, payload) {
      commit("SET_QUERY", payload)
    },
    findingInvoices({commit}, payload) {
      commit("FINDING_INVOICES", payload)
    },
    receiveInvoices({commit}, payload) {
      commit("RECEIVED_INVOICES", payload)
    },
    receiveInvoice({commit}, payload) {
      commit("RECEIVED_INVOICE", payload)
    },
    receivingInvoices({commit}) {
      commit("RECEIVING_INVOICES")
    },
    receivingInvoice({commit}) {
      commit("RECEIVING_INVOICE")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },


    updateInvoice({commit}, payload) {
      commit("UPDATED_INVOICE", payload)
    },
    updatingInvoice({commit}) {
      commit("UPDATING_INVOICE")
    },
    deleteInvoice({commit}, payload) {
      commit("DELETED_INVOICE", payload)
    },
    deletingInvoice({commit}, payload) {
      commit("DELETING_INVOICE", payload)
    }
  },
};
